import React from "react";
// import Banner from '../../components/UserSideComponents/blogs/Banner'
import YostelBlogs from "../../components/UserSideComponents/blogs/YostelBlogs";
import Blog from "../../components/UserSideComponents/blogs/Blogs";
import Banner from "../../components/UserSideComponents/abouts/Banner";
function Blogs() {
  return (
    <div>
      <Banner title="Blogs" />
      <YostelBlogs />
      <Blog />
    </div>
  );
}

export default Blogs;
